const Echo = require("laravel-echo");
const env = require("services/env");

class EchoService {

	get client() {
		if (this._client == undefined) {
			const protocol = env.get("options.echo.protocol", "http");
			const host = env.get("options.echo.host", "localhost");
			const port = env.get("options.echo.port", 6001);

			this._client = new Echo({
				broadcaster: 'socket.io',
				host: `${protocol}://${host}:${port}`,
				client: require("socket.io-client"),
				namespace: null
			});
		}

		return this._client;
	}

	chat(id) {
		return this.client.private('Chat.Channels.' + id);
	}

	notification(id) {
		return this.client.private('App.Models.User.' + id);
	}

	userState(id) {
		return this.client.private(`State.User.${id}`);
	}

}

module.exports = new EchoService();



// WEBPACK FOOTER //
// ./resources/js/services/echo.js